import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import Link from '@material-ui/core/Link';
import Button from '@material-ui/core/Button';
import IconButton from "@material-ui/core/IconButton";
import Typography from '@material-ui/core/Typography';
import ButtonBase from '@material-ui/core/ButtonBase';
import BookmarkIcon from '@material-ui/icons/Bookmark';
import BookmarkBorderOutlinedIcon from '@material-ui/icons/BookmarkBorderOutlined';
import MultilineText from './MultilineText';
import SendIcon from '@material-ui/icons/Send';
import NoImg from '../img/noimg.jpg';
import MoreIcon from "@material-ui/icons/MoreVert";
import FavoriteIcon from '@material-ui/icons/Favorite';
import FavoriteBorderOutlinedIcon from '@material-ui/icons/FavoriteBorderOutlined';
import ShareIcon from '@material-ui/icons/Share';
import Avatar from '@material-ui/core/Avatar';
import DeletePost from '../components/DeletePost';
import ViewComments from '../components/ViewComments';
import { db, auth } from '../settings/firebase';
import '../pages/Page.css';
import AuthCheck from './Authentication/Check';
import MediaQuery from 'react-responsive';
import BookmarkArea from './BookmarkArea';
import printtimeat from '../function/printtimeat';
import MultiLineText from './MultilineText';

const useStyles = makeStyles((theme) => ({
  paper: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(2),
    margin: "10px",
    width: "90%",
    maxWidth: "1000px",
    /* dropshadow_color */
  },
  // 推薦理由
  suggestTitle: {
    display: "flex",
    // フォント
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: "bold",
    fontSize: "18px",

    alignItems: "center",
    textAlign: "left",
    letterSpacing: "0.03em",
  },
  suggestComment: {
    display: "flex",
    // フォント
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: "bold",
    fontSize: "15px",
    textAlign: "left",
  },
  // 推薦記事表示領域
  suggestedView: {
    width: "80%",
    background: "#FFFFFF",
  },
  image: {
    width: "80%",
    overflow: "hidden",
  },
  img: {
    margin: 'auto',
    display: 'block',
    width: '100%',
    height: '100%',
    objectFit: "cover",
  },
  /* SuggestedContent */
  suggestedContent: {
    width: "80%",
    marginBottom: "10px",
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: "300",
    fontSize:"12px",
    textAlign: "left",
    color: "#555046",
  },
  suggestedTitle: {
    width: "80%",
    marginTop: "10px",
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize:"14px",
    textAlign: "left",
    whiteSpace: "nowrap",
    color: "#555046",
  },
  suggestedSiteName: {
    fontSize: "13px",
  },
  editBtn: {
    textAlign: "center",
    padding: "7px",
    width: "7em",
    minWidth: "5em",
    borderRadius: "20px",
    fontFamily: "Roboto",
    fontWeight: "600",
    boxShadow: "0 1px 2px #555555",
    backgroundColor: "#222222",
    color: theme.palette.secondary.main,
    '&:hover': {
      cursor: "pointer",
      textDecoration: "none",
      backgroundColor: theme.palette.primary.dark,
    }
  },
  iconBtn: {
    marginLeft: "10px",
  },
  linkBtn: {
    backgroundColor: theme.palette.primary.main,
    borderRadius: "1em",
    height: "3em",
    fontSize: "20px",
    '&:hover': {
      cursor: "pointer",
      border: "2px solid "+theme.palette.primary.main,
      backgroundColor: theme.palette.secondary.main,
      outline: "0",
    }
  },
  // メッセージ部分
  messageInput: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  messageInputArea: {
    width: "36vw",
    minWidth: "10em",
    borderRadius: "20px", display: "flex",
    backgroundColor: theme.palette.secondary.main,
    alignItems: "center", height: "40px",
    fontSize: "16px", boxShadow: "0px 2px 2px gray",
    paddingLeft: "15px", paddingRight: "15px",
    marginLeft: "20px",
    paddingTop: ".75em",
    '&:focus':{
      border: "2px solid "+theme.palette.primary.main,
      outline: "0",
    },
  },
  lefttext: {
    width: "100%",
    textAlign: "left",
    fontSize: "14px",
    marginBottom: "0"
  },
  // ページフッター
  bottompagefooter: {
    position: "fixed",
    display: "flex",
    justifyContent: "space-between",
    bottom: "0",
    left: "0",
    height: "70px",
    width: "calc(100vw - 17px)",
    backgroundColor: theme.palette.secondary.main,
  },
  bottompagefooterdiv: {
    display: "flex",
    alignItems: "center",
    height: "100%",
    marginRight: "20px",
  },
  barIcon: {
    height: "55px",
    width: "55px",
    marginLeft: "20px",
  },
  barIconImg: {
    height: "36px",
    width: "36px",
  },
}));

function PageBodyFooter(props) {
  const { data, changeStateMylike, changeStateMyselect, nowuid, messageInput, mylike, myselect } = props;
  const classes = useStyles();

  return (
    <div className={classes.bottompagefooter}>
      <MediaQuery query="(min-width: 500px)">
        <AuthCheck>
          <div className={classes.bottompagefooterdiv}>
            {messageInput}
          </div>
        </AuthCheck>
      </MediaQuery>
      <div style={{flexGrow: "1"}}/>
      <div className={classes.bottompagefooterdiv}>
        <BookmarkArea
          data={data} nowuid={nowuid}
          changeStateMylike={changeStateMylike} changeStateMyselect={changeStateMyselect}
          mylike={mylike} myselect={myselect} star={data.star}
          className={classes.barIcon} iconSize={"36px"}
        />
      </div>
    </div>
  )
}

export default function PageBody(props) {
  const classes = useStyles();
  // 渡されたデータの取得
  const { data, sharelink } = props;
  const [isEditor, setisEditor] = useState(false);
  const [nowuid, setnowuid] = useState("");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorDelPopup, setanchorDelPopup] = useState(false);
  const [anchorMessage, setanchorMessage] = useState(false);
  const [validsend, setvalidsend] = useState(false);
  const [ mylike, setmylike ] = useState(false);
  const [ myselect, setmyselect ] = useState(false);
  const [newMessage, setnewMessage] = useState("");
  const isMenuOpen = Boolean(anchorEl);
  // console.log(data)

  auth.onAuthStateChanged(user => {
    if (user) {
      setnowuid(user.uid);
      if (user.uid === data.recommender) {
        setisEditor(true);
      }
      db.collection("users").doc(user.uid).onSnapshot(doc => {
        if(doc.exists) {
          doc.data().favorite.forEach(fav => {
            if (fav.pid === data.docId) {
              setmyselect(true);
            }
          })
        }
      })
    }
  })

  const handleOptionMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleOptionMenuClose = () => {
    setAnchorEl(null);
  };

  const deletePost = async () => {
    if (anchorDelPopup) {
      setanchorDelPopup(false);
      await DeletePost(data);
      setanchorMessage(true);
    } else {
      setanchorDelPopup(true);
      handleOptionMenuClose();
    }
  };
  const deletePostPopupClose = () => {
    if (anchorDelPopup) {
      setanchorDelPopup(false);
    } else if (anchorMessage) {
      setanchorMessage(false);
      window.location.href = "/" + data.recommender;
    }
  };

  const changePostMessage = (e) => {
    setnewMessage(e.target.value);
    if (e.target.value !== "") {
      setvalidsend(true);
    } else {
      setvalidsend(false);
    }
  }

  // メッセージを送信する
  const sendMessage = async () => {
    if (validsend) {
      let messages = data.messages;
      messages.push({
        uid: nowuid,
        text: newMessage,
        like: [],
        ts: new Date(),
      });
      await db.collection("items").doc(data.docId).update({
        messages: messages,
      }).then(async () => {
        setnewMessage("");
        setvalidsend(false);
      })
      .catch((error) => {
        console.error("Error updating document: ", error);
      });
    }
  }

  // いいねの状態更新
  const changeStateMylike = (bool) => {
    setmylike(bool);
  }
  // セレクトの状態更新
  const changeStateMyselect = (bool, newstar) => {
    setmyselect(bool);
  }

  // 見てみるをクリックしたときに実行
  const clickLinkEvent = async (e) => {
    const docRef = db.collection("items").doc(data.docId);
    await db.runTransaction((transaction) => {
      return transaction.get(docRef).then((doc) => {
          if (!doc.exists) {
              throw "Document does not exist!";
          }
          let newClick = doc.data().click;
          if (nowuid === "") {
            newClick.push("annonymous");
          } else if (newClick.indexOf(nowuid) === -1 && !isEditor) {
            newClick.push(nowuid);
          }
          transaction.update(docRef, { click: newClick });
          return newClick;
      });
    }).then((newClick) => {
      window.location.href = data.url;
    }).catch((err) => {
        console.error(err);
    });
  }

  // メッセージ送信部分
  const messageInput = (
    <form noValidate autoComplete="off" className={classes.messageInput}>
      <textarea
        id="standard-basic"
        style={{height: "1.5em"}}
        value={newMessage}
        className={classes.messageInputArea}
        placeholder="いまの気持ちを書く"
        onChange={changePostMessage}
        required
      />
      <IconButton aria-label="send" disabled={!validsend} color={"primary"} onClick={sendMessage}>
        <SendIcon />
      </IconButton>
    </form>
  )

  const renderOptionMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id="accountMenu"
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      disableScrollLock={ true }
      open={isMenuOpen}
      onClose={handleOptionMenuClose}
    >
      {isEditor?
        <MenuItem component="a" onClick={deletePost}>この投稿を削除</MenuItem>
      : null }
      <MenuItem component="a" onClick={handleOptionMenuClose}>閉じる</MenuItem>
    </Menu>
  );

  // 削除の確認ポップアップ
  const renderDelPostPopup = (
    <>{anchorDelPopup?
      <div className='popup'>
        <div className='popup_inner' style={{display: "flex", alignItems: "center", justifyContent: "space-around", flexDirection: "column"}}>
          <p>一度削除すると元に戻せません。<br />本当に削除しますか？</p>
          <div>
            <Button type="button" variant="contained" color="secondary" onClick={deletePostPopupClose}>
              キャンセル
            </Button>
            <Button type="button" variant="contained" style={{marginLeft: "100px", color: "#ffffff", backgroundColor: "#ee3333"}} onClick={deletePost}>
              削除
            </Button>
          </div>
        </div>
      </div>
    :
      anchorMessage?
        <div className='popup'>
          <div className='popup_inner' style={{display: "flex", alignItems: "center", justifyContent: "space-around", flexDirection: "column"}}>
            <p>このページを削除しました。<br/>マイブックに移動します。</p>
            <div>
              <Button type="button" variant="contained" color="secondary" onClick={deletePostPopupClose}>
                了解です！
              </Button>
            </div>
          </div>
        </div>
      : null
    }</>
  )

  return (
    <div style={{display: 'flex', justifyContent: 'center'}}>
      <div className={classes.paper}>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "left", textAlign: "left"}}>
          <div style={{display: "flex", justifyContent: "left", alignItems: "center", textAlign: "left", width: "85%"}}>
            <Avatar alt={data.displayid} src={data.avatarUrl} component={Link} to={"/" + data.displayid} />
            <span style={{paddingLeft: "4px"}}>
              <Link style={{color: "#333333"}} href={"/" + data.displayid}>{data.username}</Link>
            </span>
            <div style={{flexGrow: "1"}} />
            {isEditor?
              <Link className={classes.editBtn} href={"/post?pid="+data.docId}>編集する</Link>
            : null}
            <IconButton className={classes.iconBtn} onClick={sharelink}><ShareIcon /></IconButton>
            <IconButton className={classes.iconBtn} onClick={handleOptionMenuOpen}><MoreIcon /></IconButton>
          </div>
          <ButtonBase className={classes.image}>
            <img className={classes.img} alt="complex" src={data.thumbnail} />
          </ButtonBase>
          <div style={{display: "flex", justifyContent: "flex-start", flexDirection: "column", width: "80%"}}>
            <Typography variant="body2" className={classes.suggestTitle}>
              {data.title}
            </Typography>
            <Typography variant="body2" className={classes.suggestComment}>
              <MultilineText>{data.comment}</MultilineText>
            </Typography>
            <Typography gutterBottom variant="subtitle1" className={classes.suggestedTitle}>
              {data.urlTitle}
            </Typography>
            <Typography variant="body2" className={classes.suggestedContent}>
              {data.description}
            </Typography>
            <Typography variant="h6" className={classes.suggestedSiteName}>
              {data.siteName}
            </Typography>
          </div>
        </div>
        <button onClick={clickLinkEvent} className={classes.linkBtn}>見てみる</button>
        {data.createdAt?
          <p className={classes.lefttext}>{printtimeat(data.createdAt)}投稿（{printtimeat(data.updatedAt)}更新）</p>
        : null }
        <Divider />
        <div style={{display: "flex"}}>
          <AuthCheck>
            <p className={classes.lefttext}>メッセージを残す</p>
            {messageInput}
          </AuthCheck>
        </div>
        {data.messages && data.messages.length > 0?
          <>
            <ViewComments data={data.messages} pid={data.docId}></ViewComments>
          </>
        :
          <div className={"nocomment"}>
            <Typography>まだメッセージはありません。</Typography>
          </div>
        }
        <div className={"bottomdiv"} />
        <PageBodyFooter data={data}
          changeStateMylike={changeStateMylike} changeStateMyselect={changeStateMyselect}
          nowuid={nowuid} messageInput={messageInput} myselect={myselect} mylike={mylike}
        />
        {renderOptionMenu}
        {renderDelPostPopup}
      </div>
    </div>
  );
}